import cn from 'classnames';
import LazyMotionWrapper from 'components/lazy-motion-wrapper';
import useIsClient from 'hooks/common/use-is-client';
import useMobile from 'hooks/common/use-mobile';
import dynamic from 'next/dynamic';
import ProductsList from '../products-list';
import ContentSection from './components/content-section';
import ImageSection from './components/image-section';
interface Props {
  petType: 'cat' | 'dog';
  showProductsList?: boolean;
}

const OptionSelector = dynamic(() => import('../option-selector'), {
  ssr: false,
});

/**
 * A component that allows users to select their dog's age, breed, and needs.
 * and based on the selection, it will show the list of products that match the selection.
 */
const NeedCaptureContent: React.FC<Props> = ({
  petType,
  showProductsList = true,
}) => {
  const { isClient } = useIsClient();
  const isMobile = useMobile();

  if (!isClient) return null;

  return (
    <LazyMotionWrapper>
      <div
        className={cn(
          'relative pb-6 lg:pb-2',
          petType === 'dog' ? 'bg-dog-base' : 'bg-cat-base'
        )}
      >
        <ImageSection petType={petType} />
        <div className="container">
          <ContentSection isMobile={isMobile} petType={petType} />
          {showProductsList && <ProductsList petType={petType} />}
        </div>
      </div>
      {isMobile && <OptionSelector petType={petType} />}
    </LazyMotionWrapper>
  );
};

export default NeedCaptureContent;
